export const Privacy = () => {
    return (
        <div style={{ padding: "20px", maxWidth: "800px", margin: "100px auto" }}>
            <h1>Polityka Prywatności</h1>
            <h2>serwisu Draftngo.com</h2>

            <section>
                <h3>1. Informacje ogólne</h3>
                <p>
                    Niniejsza Polityka Prywatności określa zasady przetwarzania danych osobowych użytkowników
                    korzystających z serwisu Draftngo.com (dalej: „Serwis”).
                </p>
                <p>
                    Administratorem danych osobowych jest:<br/>
                    <strong>Jan Wiczyński</strong> (dalej: „Administrator”).
                </p>
                <p>
                    Dane osobowe przetwarzane są zgodnie z przepisami prawa, w szczególności z Rozporządzeniem
                    Parlamentu Europejskiego i Rady (UE) 2016/679 („RODO”).
                </p>
            </section>

            <section>
                <h3>2. Zakres przetwarzanych danych</h3>
                <ul>
                    <li><strong>Dane identyfikacyjne:</strong> imię, nazwisko, identyfikator konta.</li>
                    <li><strong>Dane kontaktowe:</strong> adres e-mail oraz inne dane podane dobrowolnie.</li>
                    <li>
                        <strong>Dane techniczne:</strong> adres IP, informacje o urządzeniu i przeglądarce,
                        zapisy w logach serwera, dane o aktywności w Serwisie.
                    </li>
                    <li>
                        <strong>Dane z logowania przez Facebook:</strong> podstawowe informacje z profilu, takie jak
                        imię, nazwisko, adres e-mail, identyfikator konta Facebook oraz zdjęcie profilowe
                        (o ile użytkownik wyrazi zgodę).
                    </li>
                </ul>
                <p>
                    Zakres danych zależy od informacji przekazanych podczas rejestracji lub logowania przez Facebooka.
                </p>
            </section>

            <section>
                <h3>3. Cele i podstawy prawne przetwarzania</h3>
                <ul>
                    <li>
                        <strong>Założenie i obsługa konta:</strong> umożliwienie rejestracji, logowania i korzystania
                        z Serwisu — art. 6 ust. 1 lit. b RODO.
                    </li>
                    <li>
                        <strong>Komunikacja z użytkownikami:</strong> udzielanie odpowiedzi i obsługa zgłoszeń — 
                        art. 6 ust. 1 lit. b oraz art. 6 ust. 1 lit. f RODO.
                    </li>
                    <li>
                        <strong>Spełnienie obowiązków prawnych:</strong> archiwizacja, rachunkowość — 
                        art. 6 ust. 1 lit. c RODO.
                    </li>
                    <li>
                        <strong>Analiza działania Serwisu i bezpieczeństwo:</strong> monitorowanie ruchu i zapobieganie nadużyciom —
                        art. 6 ust. 1 lit. f RODO.
                    </li>
                    <li>
                        <strong>Marketing własnych usług</strong> (jeżeli stosowany) — art. 6 ust. 1 lit. f RODO oraz zgoda użytkownika.
                    </li>
                </ul>
            </section>

            <section>
                <h3>4. Logowanie za pomocą Facebooka</h3>
                <p>
                    Serwis umożliwia logowanie poprzez „Facebook Login”, dostarczany przez Meta Platforms Ireland Limited.
                    Użytkownik jest informowany o zakresie przekazywanych danych i wyraża zgodę na ich udostępnienie.
                </p>
                <p>
                    Administrator otrzymuje wyłącznie dane niezbędne do obsługi konta: identyfikator użytkownika Facebook,
                    imię i nazwisko oraz adres e-mail (jeżeli jest udostępniany).
                </p>
                <p>
                    Facebook jest odrębnym administratorem danych. Użytkownik może zarządzać uprawnieniami w ustawieniach
                    swojego konta Facebook.
                </p>
            </section>

            <section>
                <h3>5. Odbiorcy danych</h3>
                <ul>
                    <li>Podmioty przetwarzające dane na zlecenie Administratora (hostingi, IT, analityka).</li>
                    <li>Organy publiczne uprawnione na podstawie przepisów prawa.</li>
                    <li>Dostawcy usług zewnętrznych, takich jak Facebook — w zakresie wynikającym z konfiguracji usługi.</li>
                </ul>
                <p>Administrator nie sprzedaje danych osobowych podmiotom trzecim.</p>
            </section>

            <section>
                <h3>6. Przekazywanie danych poza EOG</h3>
                <p>
                    Dane są przetwarzane głównie na obszarze EOG. W przypadku usług dostawców, takich jak Meta/Facebook,
                    dane mogą być przekazywane do państw trzecich na podstawie odpowiednich zabezpieczeń, takich jak
                    standardowe klauzule umowne.
                </p>
            </section>

            <section>
                <h3>7. Okres przechowywania danych</h3>
                <ul>
                    <li>Przez okres posiadania aktywnego konta.</li>
                    <li>Przez czasu przedawnienia roszczeń.</li>
                    <li>Przez okres wymagany przepisami prawa.</li>
                </ul>
                <p>Po upływie tych okresów dane są usuwane lub anonimizowane.</p>
            </section>

            <section>
                <h3>8. Prawa użytkowników</h3>
                <ul>
                    <li>prawo dostępu do danych,</li>
                    <li>prawo sprostowania danych,</li>
                    <li>prawo usunięcia danych („prawo do bycia zapomnianym”),</li>
                    <li>prawo ograniczenia przetwarzania,</li>
                    <li>prawo sprzeciwu,</li>
                    <li>prawo przenoszenia danych,</li>
                    <li>prawo wycofania zgody w dowolnym momencie,</li>
                    <li>prawo wniesienia skargi do Prezesa UODO.</li>
                </ul>
            </section>

            <section>
                <h3>9. Pliki cookies</h3>
                <p>
                    Serwis wykorzystuje pliki cookies w celu prawidłowego działania, analityki i dostosowania
                    usług do preferencji użytkownika. Użytkownik może zmienić ustawienia cookies w swojej przeglądarce.
                </p>
            </section>

            <section>
                <h3>10. Zabezpieczenia danych</h3>
                <p>
                    Administrator wdraża odpowiednie środki techniczne i organizacyjne, w tym kontrolę dostępu,
                    zabezpieczenia serwerów oraz współpracę wyłącznie z podmiotami zapewniającymi odpowiedni poziom ochrony danych.
                </p>
            </section>

            <section>
                <h3>11. Zmiany Polityki Prywatności</h3>
                <p>
                    Polityka Prywatności może być aktualizowana w przypadku zmian prawnych lub modyfikacji
                    funkcjonowania Serwisu. Bieżąca wersja dokumentu jest zawsze dostępna na stronie.
                </p>
            </section>

            <section>
                <h3>12. Usuwanie danych (Data Deletion Request)</h3>
                <p>
                    Użytkownik może zażądać usunięcia swoich danych osobowych z Serwisu w dowolnym momencie.
                </p>
                <p>
                    Aby zainicjować proces usuwania danych, należy wysłać wiadomość e-mail na adres:<br/>
                    <strong>wiczjan@gmail.com</strong>
                </p>
                <p>
                    W treści wiadomości należy umieścić:
                </p>
                <ul>
                    <li>imię i nazwisko lub identyfikator konta,</li>
                    <li>adres e-mail powiązany z kontem,</li>
                    <li>jasną prośbę o usunięcie danych („Proszę o usunięcie wszystkich moich danych”).</li>
                </ul>
                <p>
                    Administrator usuwa dane w terminie do 30 dni od otrzymania zgłoszenia, zgodnie z obowiązującymi przepisami.
                </p>
            </section>
        </div>
    );
};
